import { createApp } from "vue";
import { createRouter, createWebHistory } from "vue-router";
import { jwtDecode } from "jwt-decode";
import App from "./App.vue";
import { geo } from "@monolith/store";
import { createStore } from "vuex";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faSatellite,
  faCircleHalfStroke,
  faSun,
  faMoon,
  faPhone,
  faEdit,
  faPlus,
  faMinus,
  faSave,
  faTrash,
  faBars,
  faSort,
  faSortUp,
  faSortDown,
  faMinusCircle,
  faPlusCircle,
  faEnvelope,
  faHouse,
  faPlug,
  faChartPie,
  faChartLine,
  faGears,
  faRightFromBracket,
  faMoneyBillWave,
  faCheck,
  faWifi,
  faTimes,
  faWrench,
  faArrowRight,
  faArrowLeft,
  faArrowUp,
  faChevronRight,
  faChevronLeft,
  faLink,
  faPencil,
  faFloppyDisk,
  faCaretDown,
  faCaretRight,
  faPenToSquare,
  faUtensils,
  faCashRegister,
  faArrowUpWideShort,
  faGlobe,
  faMeteor,
  faUserAstronaut,
  faMagnifyingGlass,
  faBackward,
  faWarehouse,
  faPersonChalkboard,
  faFileExport,
  faRoute,
  faRocket,
  faCircle,
  faFlag,
} from "@fortawesome/free-solid-svg-icons";
library.add(
  faSatellite,
  faCircleHalfStroke,
  faSun,
  faMoon,
  faPhone,
  faEdit,
  faPlus,
  faMinus,
  faSave,
  faTrash,
  faBars,
  faSort,
  faSortUp,
  faSortDown,
  faMinusCircle,
  faPlusCircle,
  faEnvelope,
  faHouse,
  faPlug,
  faChartPie,
  faChartLine,
  faGears,
  faRightFromBracket,
  faMoneyBillWave,
  faCheck,
  faWifi,
  faTimes,
  faWrench,
  faArrowRight,
  faArrowLeft,
  faArrowUp,
  faChevronRight,
  faChevronLeft,
  faLink,
  faPencil,
  faFloppyDisk,
  faCaretDown,
  faCaretRight,
  faPenToSquare,
  faUtensils,
  faCashRegister,
  faArrowUpWideShort,
  faGlobe,
  faMeteor,
  faUserAstronaut,
  faMagnifyingGlass,
  faBackward,
  faWarehouse,
  faPersonChalkboard,
  faFileExport,
  faRoute,
  faRocket,
  faCircle,
  faFlag,
);

const routes = [
  {
    path: "/",
    name: "Orders",
    component: () => import("./components/Orders.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@monolith/components/src/Login.vue"),
  },
  {
    path: "/choose-driver",
    name: "Choose Driver",
    component: () => import("./components/Auth/ChooseDriver.vue"),
  },
  {
    path: "/map",
    name: "Map",
    component: () => import("./components/Map.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/settings",
    name: "Settings",
    component: () => import("./components/Settings.vue"),
    meta: { requiresAuth: true },
  },
];

const store = createStore({
  modules: {
    geo: geo,
  },
  //plugins: [createLogger()];
});

export default store;

const router = createRouter({
  history: createWebHistory(),
  routes,
});

const isAuthenticated = async () => {
  let token = localStorage.getItem("token");
  if (token) {
    const decoded = jwtDecode(token);
    const now = parseInt(Date.now() / 1000);
    if (decoded.exp < now) {
      return false;
    }
    return true;
  } else {
    return false;
  }
};

router.beforeEach(async (to, from, next) => {
  const authenticated = await isAuthenticated();
  if (to.meta.requiresAuth) {
    if (authenticated) {
      return next();
    }
    return next({ name: "Login" });
  }
  return next();
});

const app = createApp(App);

const vm = app.use(router).use(store).component("font-awesome-icon", FontAwesomeIcon).mount("#app");
window.geoBeamy = vm;
